import styled from "styled-components";
import ImageFond from "../../image/BgGroup.png"

export const ConnexionBody = styled.div`
    background-image: url(${ImageFond});
    background-repeat: no-repeat;
    background-size: cover;
    width: 100% !important;
    height: 100vh !important;
`;